import { SignUp } from "../../../features";

const SignUpPage = () => {
  return <SignUp />;
};

export default SignUpPage;
